import React from "react";

type IconProps = {
  size?: number | string;
  color?: string;
};

export const SkipBackward15Icon = ({ size, color }: IconProps): JSX.Element => {
  return (
    <svg
      width={size || "24px"}
      height={size || "24px"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4891 16.5439C17.9819 15.9758 19.2356 14.9143 20.0421 13.5356C20.8486 12.1569 21.1593 10.5438 20.9228 8.96418C20.6863 7.38452 19.9167 5.93323 18.7418 4.85118C17.5669 3.76912 16.0573 3.12137 14.4635 3.01542C12.8698 2.90948 11.2877 3.35171 9.97992 4.26872C8.67211 5.18574 7.7172 6.52239 7.27368 8.05684"
        stroke={color || "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99874 3V8.0915L12.0508 7.46397"
        stroke={color || "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.97336 15.16C3.21336 15.16 3.44669 15.14 3.67336 15.1C3.90003 15.06 4.10336 14.9933 4.28336 14.9C4.47003 14.8067 4.62669 14.6867 4.75336 14.54C4.88669 14.3933 4.97336 14.2133 5.01336 14H5.94336V21H4.69336V16.06H2.97336V15.16ZM9.23 14H12.85V15.02H10.08L9.72 16.8L9.74 16.82C9.89333 16.6467 10.0867 16.5167 10.32 16.43C10.56 16.3367 10.7967 16.29 11.03 16.29C11.3767 16.29 11.6867 16.35 11.96 16.47C12.2333 16.5833 12.4633 16.7467 12.65 16.96C12.8367 17.1667 12.9767 17.4133 13.07 17.7C13.17 17.9867 13.22 18.2967 13.22 18.63C13.22 18.91 13.1733 19.2 13.08 19.5C12.9933 19.7933 12.85 20.0633 12.65 20.31C12.4567 20.55 12.2067 20.75 11.9 20.91C11.5933 21.0633 11.2267 21.14 10.8 21.14C10.46 21.14 10.1433 21.0933 9.85 21C9.56333 20.9133 9.31 20.78 9.09 20.6C8.87 20.42 8.69333 20.2 8.56 19.94C8.43333 19.6733 8.36333 19.3633 8.35 19.01H9.49C9.52333 19.39 9.65333 19.6833 9.88 19.89C10.1067 20.09 10.4067 20.19 10.78 20.19C11.02 20.19 11.2233 20.15 11.39 20.07C11.5567 19.99 11.69 19.88 11.79 19.74C11.8967 19.6 11.97 19.4367 12.01 19.25C12.0567 19.0633 12.08 18.8633 12.08 18.65C12.08 18.4567 12.0533 18.2733 12 18.1C11.9467 17.92 11.8667 17.7633 11.76 17.63C11.6533 17.4967 11.5133 17.39 11.34 17.31C11.1733 17.23 10.9767 17.19 10.75 17.19C10.51 17.19 10.2833 17.2367 10.07 17.33C9.86333 17.4167 9.71333 17.5833 9.62 17.83H8.48L9.23 14Z"
        fill={color || "white"}
      />
    </svg>
  );
};

export default SkipBackward15Icon;
